import { useSelector } from "react-redux";
import Preview from "../components/Preview";

const PreviewContainer = () => {
  const cards = useSelector((state) => state.cards);
  return <Preview cards={cards} />;
};

export default PreviewContainer;
